import React, { useEffect } from 'react'
import { useVsgSdk } from 'alelo-logic/contexts/vsgSdkContext'
import qs from 'qs'
import { removeAuthObj } from 'alelo-logic/services/common/storage'

const Mfa = props => {
  document.title = 'Minha Veloe | MFA'
  const vsgSdk = useVsgSdk()
  const { token, resource, nextUrl, previousUrl } = qs.parse(props.location.search, {
    ignoreQueryPrefix: true
  })

  if (!token) {
    props.history.push('/conta/login')
    return
  }

  useEffect(() => {
    const mfaComponent = vsgSdk.renderizarMfa({
      jwtToken: token,
      resource: resource
    })

    mfaComponent.on('cancelar', () => {
      props.history.push(previousUrl)

      if (previousUrl === '/conta/login') {
        removeAuthObj()
      }
    })

    mfaComponent.on('erro', () => {
      if (resource) return

      props.history.push('/conta/login')
    })

    mfaComponent.on('sucesso', () => {
      props.history.push(nextUrl)
    })
  }, [vsgSdk, token, resource, nextUrl, previousUrl])

  return <div id="vsg-mfa" data-testid="vsg-mfa" />
}

export default Mfa
